import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';
import { AbsProduct, Product } from '@/creditflowresearch/domain/Product';
import { useAccessGrant } from '@/creditflowresearch/application/User/access/grants/useAccessGrant';
import { useIsGuest } from '@/creditflowresearch/application/User/access';

export const useRestrictedAccess = (withGuest: boolean = false) => {
  const { isStarter, products } = useUserPlanContext();
  const isOnlyAbsAccess = Product.areAllOfType(products, AbsProduct.TYPE);
  const granted = useAccessGrant();
  const isGuest = useIsGuest() && withGuest;

  return (isGuest || isStarter || isOnlyAbsAccess) && granted;
};
